import { render, staticRenderFns } from "./TrendHint.vue?vue&type=template&id=55e92f0e&"
import script from "./TrendHint.vue?vue&type=script&lang=js&"
export * from "./TrendHint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TrendHint.vue"
export default component.exports